import React from "react";
import FormsButton from "../../components/FormSection/FormsButton";
import classes from "../../components/FormSection/FormsButton.module.css";

const linkItems = [
  {
    name: "Loan Document Order Form",
    href: "/broker/loan-document-order-form",
  },
  {
    name: "Loan Servicing Order Form",
    href: "/broker/loan-servicing-order-form",
  },
  { name: "Demand Request Form", href: "/broker/demand-request-form" },
  {
    name: "Verification of Mortgage",
    href: "/broker/verification-of-mortgage",
  }, // Update the paths accordingly
  { name: "1003 Loan Application", href: "/broker/1003-loan-application" },
  {
    name: "Statement of Information",
    href: "/broker/statement-of-information",
  },
  { name: "Signature Authorization", href: "/broker/signature-authorization" },
  { name: "Add'l Lender Form", href: "/broker/additional-lender-form" },
];

const BrokerForms = () => {
  return (
    <section
      className="text-start container-fluid my-4 px-0 rounded"
      style={{ background: "#eeeeee", minHeight: "100vh" }}
    >
      <div className="container-fluid">
        <div className="p-3 pb-0  mt-1">
          <div style={{ backgroundColor: "#FF8057", padding: "36px 0" }}>
            <h3
              style={{
                fontSize: "55px",
                color: "#fff",
                textAlign: "center",
                padding: "17px 0",
              }}
            >
              Broker Forms
            </h3>
          </div>
          <FormsButton
            heading="Loan servicing forms"
            options={linkItems}
            classname={classes.background}
          />
        </div>
      </div>
    </section>
  );
};

export default BrokerForms;
